import { HistoricalDataResponse } from "./HistoricalDataTypes.js";
import { SessionHandler } from "./SessionHandler.js";

export class HistoricalDataAPI {
    static async getData(
        startTime: Date,
        endTime: Date,
        sources: string[] = undefined,
        dataTypes: string[] = undefined,
        options: Partial<{
            compress: boolean;
            relevantZoneIDs: string[];
        }> = {
            compress: true,
            relevantZoneIDs: undefined,
        },
    ): Promise<HistoricalDataResponse[]> {
        let result = undefined;

        const response = await SessionHandler.doFetch("historicalData/getDataCompressed", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                compress: options.compress ? "true" : "false",
            },
            method: "POST",
            redirect: "follow",
            body: JSON.stringify({
                startDate: startTime.toISOString(),
                endDate: endTime.toISOString(),
                sources: sources,
                dataTypes: dataTypes,
                relevantZoneIDs: options.relevantZoneIDs,
            }),
        });
        if (!response.ok) {
            throw Error(`Error requesting historical data, response code ${response.status}`);
        }
        result = {
            getDataRangeCompressed: (await response.json()).historicalData,
        };

        if (result && result.getDataRangeCompressed) {
            result.getDataRangeCompressed.forEach((historicalResponse) => {
                historicalResponse.data.forEach((dp) => {
                    dp.date = new Date(dp.d ?? dp.date);
                    dp.value = dp.v ?? dp.value;
                });
            });
            return result.getDataRangeCompressed;
        } else {
            throw new Error("Could not fetch data");
        }
    }
}
